// extracted by mini-css-extract-plugin
module.exports = {"CheckboxTd":"PluginDiv_CheckboxTd__3X2y_","PluginDivBody":"PluginDiv_PluginDivBody__2h7KE"};